import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import { toChecksumAddress } from 'web3-utils'
import { useRoute, useRouter } from 'vue-router'

import SelectAccount from './SelectAccount.vue'
import { InternalMethods } from '@/shared/apis/messages'
import { useAppStore } from '@/popup/store/AppStore'
import { useUIStore } from '@/popup/store/UIStore'
import { useApprovalsStore } from '@/popup/store/ApprovalsStore'
import { checkForLastPopupState } from '@/popup/utils/checkForLastPopupState'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { redirectAfterApproval } from '@/popup/utils/redirectAfterApproval'
import { removeSchemaFromUrl, truncateMiddle } from '@/shared/utils'
import { PopupDatabase } from '@/popup/storage/Database'
import Sanitize from '@/popup/components/shared/Sanitize.vue'
import IconButton from '@/popup/components/shared/IconButton.vue'
import { APPROVAL_ACTION, ApprovalOutput } from '@/shared/apis/approvals'


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestAccounts',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const uiStore = useUIStore()
const appStore = useAppStore()
const approvalsStore = useApprovalsStore()
const approval = approvalsStore.getApproval(route.params['id'])!
const selected = ref<string[]>([])

onMounted(async () => {
  if (approval?.origin) {
    const app = await PopupDatabase.getAuthenticatedAppByOrigin(approval.origin)
    if (app) {
      selected.value = [app.profileAddress]
    }
  }
})

const handleAccept = async (selected: string[], action: APPROVAL_ACTION) => {
  const globals = useGlobals()

  const approvalDirective = await globals.sendMessage({
    method: InternalMethods.HANDLE_APPROVAL,
    payload: {
      action,
      requestId: approval.id,
      data: { profileAddresses: selected } as ApprovalOutput<'requestAccounts'>,
    },
  })
  approvalsStore.processDirective(approvalDirective)

  if (
    action === 'CONFIRMED' &&
    approvalsStore.nonStashedApprovals.length === 0
  ) {
    const data = await globals.sendMessage({
      method: InternalMethods.SWITCH_PROFILE,
      payload: { address: toChecksumAddress(selected[0]) },
    })
    const lastPopupState = await checkForLastPopupState(data.selectedProfile)
    await appStore.init(data, lastPopupState, uiStore.isPopup)
  }

  redirectAfterApproval(
    router,
    approvalsStore.nonStashedApprovals.length,
    appStore.lastPopupState?.path
  )
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectAccount, {
    "handle-accept": handleAccept,
    "default-selected-keys": selected.value,
    "only-one-selection": true
  }, {
    title: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('select_account.request_profile')), 1 /* TEXT */)
    ]),
    subtitle: _withCtx(() => [
      _createVNode(Sanitize, {
        html: _unref(truncateMiddle)(_unref(removeSchemaFromUrl)(_unref(approval)?.origin), 25)
      }, null, 8 /* PROPS */, ["html"])
    ]),
    actions: _withCtx(() => [
      _createVNode(IconButton, {
        class: "button-cancel",
        tooltip: _ctx.$t('sign.cancel'),
        onOnClick: _cache[0] || (_cache[0] = ($event: any) => (handleAccept([], 'REJECTED')))
      }, null, 8 /* PROPS */, ["tooltip"])
    ]),
    "select-account-title": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('select_account.select_profile')), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["default-selected-keys"]))
}
}

})